import { html } from "lit";
import { getDummyText } from "../../../utils";

const hotSpots = [
    {
        id: "1",
        number: "1",
        title: "Beladen",
        icon: "",
        bullet: false,
        info: html`<div>
            <h2>Foo1</h2>
            <p>Lorem Ipsum</p>
            <p>Lorem Ipsum</p>
        </div>`,
        left: 20,
        top: 10,
        detailText: getDummyText(2000),
    },
    {
        id: "2",
        number: "2",
        title: "Schneiden",
        icon: "",
        bullet: false,
        info: html`<div>
            <h2>Foo2</h2>
            <p>2Lorem 2Ipsum</p>
        </div>`,
        left: 44,
        top: 50,
        detailText: getDummyText(1500),
    },
    {
        id: "3",
        number: "3",
        title: "Entladen",
        icon: "",
        bullet: false,
        info: html`<div>
            <h2>Foo3</h2>
            <p>3Lorem 3Ipsum</p>
        </div>`,
        left: 64,
        top: 20,
        detailText: getDummyText(56),
    },
    {
        id: "4",
        number: "4",
        title: "Software",
        icon: "",
        bullet: false,
        info: html`<div>
            <h2>Foo4</h2>
            <p>4Lorem 4Ipsum</p>
        </div>`,
        left: 22,
        top: 55,
        detailText: getDummyText(2000),
    },
];

export const HotspotTemplate = () => html`
    <div>
        <div class="row" id="c2041">
            <div class="webspecialWrapper">
                <div
                    class="gr-12 u-textCenter no-gutter u-clearfix u-marginTop-50 u-marginBottom-50 u-headline-inModule"
                >
                    <h1 class="headline-big">
                        Die Vorteile unserer Laser-Rohrschneidmaschinen
                    </h1>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- cbm_copy-centered - TYPO3-Content-Elements-Text-Centered -->

            <div class="webspecialWrapper">
                <div
                    class="push-2 gr-8 gr-12@m push-0@m no-gutter u-marginBottom-50 "
                >
                    <div class="block block-centered-text">
                        <div class="text-normal u-textCenter">
                            <p>
                                Der wirtschaftliche Druck in der konventionellen
                                Rohrbearbeitung steigt. Mit dem Laser sparen Sie
                                ganze Prozessschritte – und dadurch bares Geld.
                                Gleichzeitig erweitern Sie Ihr Teilespektrum und
                                somit Ihren Kundenkreis. Als Weltmarktführer in
                                der Lasertechnik und im Werkzeugmaschinenbau
                                sind wir der innovative Schrittmacher am Markt
                                und bieten Ihnen damit ideale Lösungen für die
                                Welt des Laser-Rohrschneidens.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ux-iws-hot-spot-container>
            <div slot="image">
                <img src="./mock-assets/images/trumpf-outdoor.jpg" />
            </div>
            <div slot="hot-spots">
                ${hotSpots.map(
                    (spot) =>
                        html`<ux-iws-hot-spot
                            hot-spot-id="${spot.id}"
                            number="${spot.number}"
                            icon="${spot.icon}"
                            left="${spot.left}"
                            top="${spot.top}"
                            bullet="${spot.bullet}"
                        >
                            ${spot.title !== "" ? html`${spot.title}` : ""}
                        </ux-iws-hot-spot>`
                )}
            </div>
            <div slot="info-box">
                ${hotSpots.map(
                    (spot) => html`
                        <ux-iws-hot-spot-info hot-spot-id="${spot.id}">
                            ${spot.info}
                            <a
                                class="ux-button ux-button--green"
                                href="${`#tab-${spot.id}`}"
                            >
                                Mehr erfahren
                            </a>
                        </ux-iws-hot-spot-info>
                    `
                )}
            </div>
        </ux-iws-hot-spot-container>
        <ux-iws-hot-spot-nav
            tab-container-id="hotspot-tabs"
            show-numbers
            show-scroll-to-top
        ></ux-iws-hot-spot-nav>
        <ux-tab-container anchor-navigation no-navigation id="hotspot-tabs">
            ${hotSpots.map(
                (spot) =>
                    html`<ux-tab
                        id="${`tab-${spot.id}`}"
                        tab-id="${spot.id}"
                        name="${spot.title}"
                    >
                        <div>${spot.title}</div>
                        <p>${spot.detailText}</p>
                    </ux-tab>`
            )}
        </ux-tab-container>
    </div>
`;
